import { normalize, schema } from 'normalizr';

import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'shop';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'shopID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);

// Shop Transformer
export const { transformer, listTransformer } = createRetailTransformers('Shop');
